export default __webpack_public_path__ + "static/media/postgresql_plain_wordmark_logo_icon_146390.f123d36d.svg";